export default class OffsiteModal {
    constructor() {
        this.events();
    }

    events() {
        document.body.addEventListener("click", (e) => {
            if (e.target.tagName === "IMG" && e.target.parentElement.tagName === "A" && e.target.parentElement.href.indexOf(location.hostname) === -1) {
                e.preventDefault();
                this.showModal(e.target.parentElement.href);
            } else if (e.target.tagName === "A" && e.target.href.indexOf(location.hostname) === -1) {
                e.preventDefault();
                this.showModal(e.target.href);
            }
        });

    }

    // show modal should fetch the offsite-modal.html file and append it to the body
    // then add event listeners to the modal buttons
    showModal(url) {
        let modalBasePath = "";

        if (
            window.location.href.indexOf("belotero.local") > -1 ||
            window.location.href.indexOf("beloterostg.wpenginepowered.com") > -1
        ) {
            modalBasePath = "/wp-content/themes/mtpress/parts/offsite-modal.html";
        } else {
            modalBasePath = "/app/themes/mtpress/parts/offsite-modal.html";
        }

        fetch(modalBasePath)
            .then((response) => response.text())
            .then((data) => {
                document.body.insertAdjacentHTML("beforeend", data);
                this.addEventListeners(url);
            });
    }

    // add event listeners to the modal buttons
    addEventListeners(url) {
        document.querySelector(".form-button.close").addEventListener("click", (e) => {
            e.preventDefault();
            document.querySelector("#offsite-modal").remove();
        });

        document.querySelector(".form-button.continue").addEventListener("click", (e) => {
            e.preventDefault();
            window.open(url, "_blank");
            document.querySelector("#offsite-modal").remove();
        });
    }
}